import { render, staticRenderFns } from "./index.vue?vue&type=template&id=89e8f1d6&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('89e8f1d6')) {
      api.createRecord('89e8f1d6', component.options)
    } else {
      api.reload('89e8f1d6', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=89e8f1d6&", function () {
      api.rerender('89e8f1d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/brand/list/children/detail/index.vue"
export default component.exports